import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type MediaAssetDto = {
  _id: string;
  fileName: string;
  originalName: string;
  mimeType: string;
  size: number;
  url: string;
  width?: number;
  height?: number;
  altText?: string;
  createdAt?: string;
};

@Injectable({ providedIn: 'root' })
export class MediaService {
  private readonly api = inject(ApiService);
  private readonly http = inject(HttpClient);

  list() {
    return this.api.get<ApiEnvelope<MediaAssetDto[]>>('platform/media').pipe(map((r) => r.data));
  }

  getById(id: string) {
    return this.api.get<ApiEnvelope<MediaAssetDto>>(`platform/media/${id}`).pipe(map((r) => r.data));
  }

  upload(file: File, metadata: { altText?: string } = {}): Observable<MediaAssetDto> {
    const form = new FormData();
    form.append('file', file);
    if (metadata.altText) form.append('altText', metadata.altText);
    return this.http
      .post<ApiEnvelope<MediaAssetDto>>(`${this.api.baseUrl}/platform/media/upload`, form, { withCredentials: true })
      .pipe(map((r) => r.data));
  }

  update(id: string, payload: { altText?: string }) {
    return this.api.patch<ApiEnvelope<MediaAssetDto>>(`platform/media/${id}`, payload).pipe(map((r) => r.data));
  }

  remove(id: string) {
    return this.api.delete<ApiEnvelope<{ deleted: boolean }>>(`platform/media/${id}`).pipe(map((r) => r.data));
  }
}
